import * as layout from '../layout.js';
import * as promotionSlider from '../template-parts/layout/promotionSlider.js';
